export default "__VITE_ASSET__CWatPKf$__"